export enum ModelActionType {
  SAY = 'SAY',
  HIBERNATE = 'HIBERNATE',
  MODIFY_CART = 'MODIFY_CART',
  ADD_TO_CART = 'ADD_TO_CART',
  NONE = 'NONE',
}
